import { UserPlus, Utensils, Bell, ChefHat, Wallet } from "lucide-react";

const HomeChefCurationOfExcellence = () => {
  const steps = [
    {
      stepNumber: "01",
      icon: <UserPlus size={24} strokeWidth={1.5} />,
      title: "Join Us",
      desc: "Apply through our simple onboarding process.",
    },
    {
      stepNumber: "02",
      icon: <Utensils size={24} strokeWidth={1.5} />,
      title: "Set Your Menu",
      desc: "Upload recipes and set availability.",
    },
    {
      stepNumber: "03",
      icon: <Bell size={24} strokeWidth={1.5} />,
      title: "Get Orders",
      desc: "Customers discover and order your dishes.",
    },
    {
      stepNumber: "04",
      icon: <ChefHat size={24} strokeWidth={1.5} />,
      title: "Cook & Pack",
      desc: "Prepare meals with our quality standards.",
    },
    {
      stepNumber: "05",
      icon: <Wallet size={24} strokeWidth={1.5} />,
      title: "Get Paid",
      desc: "Receive weekly payouts directly to your bank.",
    },
  ];

  return (
    <section className="hc-section">
      <div className="container text-center">
        <span className="hc-section-overline">THE ARCHITECTURE OF SUCCESS</span>
        <h2 className="hc-section-title">A Curation of Excellence</h2>

        {/* Bootstrap Grid for Steps */}
        <div className="row justify-content-center mt-5 g-4">
          {" "}
          {/* g-4 adds consistent gutters */}
          {steps.map((s, i) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-2 text-center"
              key={i}
            >
              <div className="hc-step d-flex flex-column align-items-center h-100">
                {/* Step Number Badge */}
                <div className="hc-step-number mb-3">{s.stepNumber}</div>

                {/* Icon Box */}
                <div className="hc-step-icon mb-3">{s.icon}</div>

                {/* Title & Description */}
                <h6 className="mb-2" style={{ color: "#371b17" }}>
                  {s.title}
                </h6>
                <p className="hc-muted small mb-0">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeChefCurationOfExcellence;
